import client from '../../base-api';

const serviceURL = '/private-coaching-overview';
const inquiryServiceURL = '/private-coaching-inquiry-overview';

const overviewPrivateCoachingService = {
    getNewAndActiveList(filterData: any) {
        return client.get(`${serviceURL}/new-and-active`, {params: filterData});
    },
    getFinishedList(filterData: any) {
        return client.get(`${serviceURL}/finished`, {params: filterData});
    },
    getArchivedList(filterData: any) {
        return client.get(`${serviceURL}/archived`, {params: filterData});
    },


    // Inquiry
    getInquiryOverviewList(filterData: any) {
        return client.get(`${inquiryServiceURL}`, {params: filterData});
    },

}

export default overviewPrivateCoachingService;